(() => {
  function initCarousel(carousel) {
    if (carousel.dataset.ulCarouselReady === 'true') return;
    const track = carousel.querySelector('.collab-track');
    const slides = [...(track?.children || [])];
    const dots = [...carousel.querySelectorAll('[data-goto]')];
    if (!track || slides.length < 2) return;

    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      if (window.matchMedia('(max-width: 749px)').matches) {
        track.style.transform = 'none';
        track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      } else {
        track.style.transform = `translate3d(${-100 * index}%,0,0)`;
      }
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
    };

    carousel.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.goto))));
    carousel.dataset.ulCarouselReady = 'true';
    show(0);
  }

  function init(scope = document) {
    scope.querySelectorAll?.('.ul-static--colaboraciones [data-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
